export enum USER_ROLES_ENUM {
  ADMIN = 'ADMIN'
}
